import React, { useState } from 'react'
import DetailLog from 'tennders-transactions/views/log/DetailLog'
import DetailDocuments from 'tennders-documents/views/DetailDocuments'
import MiniMarketPlaceOffers from 'tennders-market/offer/views/MiniMarketPlaceOffers'
import useSession from 'tennders-auth/hooks/useSession'
import useTranslation from 'next-translate/useTranslation'
import { STATUS_WAITING_FOR_OFFER, STATUS_CANCELLED } from 'tennders-stracture/libs/constants'

const TransactionSharedView = (props) => {
  const { transaction } = props
  const [activeView, setActiveView] = useState('docs')
  const { isBroker } = useSession()
  const { t } = useTranslation()
  const toggleView = (view, force) => {
    if (view === activeView) {
      if (force) {
        return
      }
      setActiveView(null)
    } else {
      setActiveView(view)
    }
  }

  return (
    isBroker()
      ? (
        <ul className="tennders-accordion-list">
          <li className={activeView === 'offers' ? 'active' : ''}>
            <MiniMarketPlaceOffers
              onToggle={(force) => toggleView('offers', force)}
              show={activeView === 'offers'}
              transaction={transaction}
            />
          </li>
          <li className={activeView === 'docs' ? 'active' : ''}>
            <h4 className="bold" onClick={() => toggleView('docs')}>
              {transaction?.matchedLoad ? t('transaction:shippersDocs') : t('transaction:carriersDocs')}
            </h4>
            <div
              style={activeView === 'docs' ? { display: 'block' } : { display: 'none' }}
              className="tennders-accordion-content carriers-documents-max-height tennders-custom-scroll mt-16"
            >
              {(transaction?.bookedBy || transaction?.status?.label === STATUS_CANCELLED) && (!transaction?.isOfferable || transaction?.status?.label !== STATUS_WAITING_FOR_OFFER) && (
                <DetailDocuments transaction={transaction} />
              )}
            </div>
          </li>
          <li>
            <DetailLog />
          </li>
        </ul>
      )
      : <MiniMarketPlaceOffers show transaction={transaction} />
  )
}

export default React.memo(TransactionSharedView)
